import { useMemo, useState, useEffect } from 'react';
import qs from 'querystring';
import moment from 'moment';

const getDefaults = queryParams => {
  const start = queryParams.startDate
    ? moment(queryParams.startDate).toDate()
    : moment()
        .subtract(30, 'days')
        .startOf('day')
        .toDate();
  const end = queryParams.endDate
    ? moment(queryParams.endDate).toDate()
    : moment()
        .endOf('day')
        .toDate();
  return { start, end };
};

// Custom hook which sets start,end date in queryString in ISO format
export function useQueryDate(props) {
  const { location, history } = props;
  const { search } = location;
  const queryParams = qs.parse(search.slice(1));
  const { start, end } = useMemo(() => getDefaults(queryParams), [queryParams]);
  const [queryDate, setQueryDate] = useState({
    start,
    end,
  });

  useEffect(() => {
    if (queryParams) {
      const { startDate, endDate } = queryParams;
      const serializedStart = moment(queryDate.start).toISOString();
      const serializedEnd = moment(queryDate.end).toISOString();
      // To avoid infinite loops caused by history.replace (which triggers the history object to change)
      // Check to see if our tag is going to change and only update the query param if that is true
      if (startDate !== serializedStart || endDate !== serializedEnd) {
        const updatedQueryParams = {
          ...queryParams,
          startDate: serializedStart,
          endDate: serializedEnd,
        };
        history.replace({
          ...location,
          search: qs.stringify({
            ...updatedQueryParams,
          }),
        });
      }
    }
    // eslint-disable-next-line
  }, [queryDate]);
  return [queryDate, setQueryDate];
}
